export default "__VITE_ASSET__CIgTkZfa__"